export default "__VITE_ASSET__lFGMvKo6__"